import React from 'react';
import { Container, Stack } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { CoverImageRenderer, ICoverImageRenderer } from './CoverImageRenderer';
import { AuditionDetails } from './AuditionDetails';
import { AuditionSuggestion, IAuditionSuggestion } from './AuditionSuggestion';
import RoleRenderer from './RoleRenderer';
import { AuditionDescription } from './AuditionDescription';
import AttachmentRenderer from './AttachmentRenderer';
import { CompanyCard } from '../Cards/CompanyCard';
import { AuditionWorkDetails } from './AuditionWorkDetails';
import { UnionAffiliation } from './UnionAffiliation';

export interface IAuditionWrapper extends ICoverImageRenderer, IAuditionSuggestion {}

const AuditionWrapper: React.FC<IAuditionWrapper> = props => {
    const { device } = useThemeContext();
    return (
        <Container
            disableGutters={device.isMobile}
            maxWidth={false}
            sx={{
                height: {
                    xs: '100dvh',
                    sm: '100%',
                },
            }}>
            <Stack
                gap={2}
                width={'100%'}
                direction={{
                    xs: 'column',
                    sm: 'row',
                }}
                alignItems={{
                    xs: 'flex-start',
                }}>
                <Stack
                    width={'100%'}
                    pb={{
                        xs: 35, // Controls the audition suggestion box heght
                        sm: 20,
                    }}>
                    <Stack
                        gap={2}
                        direction={{
                            xs: 'column',
                            sm: 'row',
                        }}
                        alignItems={{
                            xs: 'flex-start',
                        }}>
                        <CoverImageRenderer {...props} />
                    </Stack>
                    <AuditionDescription {...props} />
                    <AuditionDetails {...props} />
                    <UnionAffiliation {...props} />
                    <AuditionWorkDetails {...props} />
                    <RoleRenderer {...props} />
                    <AttachmentRenderer {...props} />
                    {!device.isDesktop &&
                        props.audition.production_company &&
                        props.audition.production_company._id && (
                            <CompanyCard data={props.audition.production_company} enableHeader />
                        )}
                </Stack>
                {device.isDesktop && <AuditionSuggestion {...props} />}
            </Stack>
            {device.isTablet && !device.isMobile && <AuditionSuggestion disableSuggestion {...props} />}
            {device.isMobile && (
                <Stack
                    sx={{
                        position: 'fixed',
                        bottom: -20,
                        left: 0,
                        width: '100%',
                        zIndex: 10, // Ensure it's above other content
                    }}>
                    <AuditionSuggestion {...props} disableSuggestion />
                </Stack>
            )}
        </Container>
    );
};

export { AuditionWrapper };
